import { atom } from 'jotai'

const ethPriceAtom = atom(0)
const solPriceAtom = atom(0)

export const rwEthPriceAtom = atom(
  (get) => get(ethPriceAtom),
  (_get, set, ethPrice: number) => {
    set(ethPriceAtom, ethPrice)
  }
)

export const rwSolPriceAtom = atom(
  (get) => get(solPriceAtom),
  (_get, set, solPrice: number) => {
    set(solPriceAtom, solPrice)
  }
)
